// extracted by mini-css-extract-plugin
export var activeFilterButton = "_kn-c";
export var backButton = "_kn-4";
export var backIcon = "_kn-5";
export var chevronShortcut = "_kn-6";
export var container = "_kn-1";
export var editor = "_kn-8";
export var editorWrapper = "_kn-7";
export var prefix = "_kn-2";
export var searchIcon = "_kn-3";
export var suffix = "_kn-9";
export var suffixContent = "_kn-a";
export var suffixText = "_kn-b";
export var wrapper = "_kn-0";